import React from 'react';

import { Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';

import loadable from '@loadable/component';
import Layout from './components/layout/layout';

import Main from './pages/main/main';

import Support from './pages/support/support';
import SupportFaq from './pages/support_faq/support_faq';
import SupportFaqDetail from './pages/support_faq_detail/support_faq_detail';
import SupportArchive from './pages/support_archive/support_archive';

import Case from './pages/case/case';

import NotFound from './pages/not_found/not_found';

//import LogTracker from './components/log_tracker/log_tracker';
import SEOMetaTag from './components/SEO_meta_tag/SEO_meta_tag';

import 'normalize.css';
import './app.css';

const Solution = loadable(() => import('./pages/solution/solution'));

const HardWare = loadable(() => import('./pages/hardware/hardware'));
const HardwareDetail = loadable(() =>
  import('./pages/hardware_detail/hardware_detail')
);
const Pick = loadable(() => import('./pages/pick/pick'));

const Notice = loadable(() => import('./pages/notice/notice'));
const NoticeNews = loadable(() => import('./pages/notice_news/notice_news'));
const NoticeUpdate = loadable(() =>
  import('./pages/notice_update/notice_update')
);

const PrivacyPolicy = loadable(() =>
  import('./pages/privacy_policy/privacy_policy')
);

const EmailSecurity = loadable(() =>
  import('./pages/email_security/email_security')
);

const Agency = loadable(() => import('./pages/agency/agency'));

/* const FairForm = loadable(() => import('./pages/fair_form/fair_form'));
const FairFormList = loadable(() =>
  import('./pages/fair_form_list/fair_form_list')
);
 */
function App() {
  /* useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-576GLP3',
    };

    TagManager.initialize(tagManagerArgs);
  }, []); */

  const preFetchPage = (page) => {
    if (page.includes('support')) return;

    if (page.includes('solution')) {
      Solution.preload();
    } else if (page.includes('hardware')) {
      HardWare.preload();
      HardwareDetail.preload();
    } else if (page.includes('notice')) {
      Notice.preload();
    }
  };

  return (
    <div className='App'>
      <BrowserRouter>
        <SEOMetaTag />
        <Routes>
          <Route path='/' element={<Main preFetch={preFetchPage} />} />
          <Route path='/main' element={<Main preFetch={preFetchPage} />} />
          <Route path='/privacy' element={<PrivacyPolicy />} />
          <Route path='/email' element={<EmailSecurity />} />

          <Route element={<Layout preFetch={preFetchPage} />}>
            <Route path='/solution/*' element={<Solution />}>
              <Route path='kiosk' element={<Solution type='kiosk' />} />
              <Route path='pos' element={<Solution />} />
              <Route path='ukiki' element={<Solution />} />
              <Route path='management' element={<Solution />} />
            </Route>

            <Route path='/hardware' element={<HardWare />}>
              <Route path='pos' element={<HardWare />} />
              <Route path='kiosk' element={<HardWare />} />
              <Route path='others' element={<HardWare />} />
            </Route>
            <Route path='/hardware/:type/:item' element={<HardwareDetail />} />
            <Route path='/hardware/kiosk/pick' element={<Pick />} />

            <Route path='/case/:type' element={<Case />}>
              <Route path='catering' />
              <Route path='hot_spicy_pot' />
              <Route path='unmanned' />
            </Route>

            <Route path='/support' element={<Support />}>
              <Route path='faq' element={<SupportFaq />} />
              <Route path='archive' element={<SupportArchive />} />
            </Route>
            <Route path='/support/faq/:faqId' element={<SupportFaqDetail />} />

            <Route path='/notice/news' element={<Notice />} />
            <Route path='/notice/news/:year/:event' element={<NoticeNews />} />
            <Route path='/notice/update' element={<NoticeUpdate />} />
          </Route>

          {/* temp */}
          <Route path='/agency' element={<Agency />} />
          {/* <Route path='/fair' element={<FairForm />} />
          <Route path='/fair/list' element={<FairFormList />} /> */}

          <Route path='/*' element={<NotFound />} />
        </Routes>
        {/* <LogTracker /> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
